import React from 'react';
import { Loading } from '@tencent/spaui';
import { connect } from 'react-redux';

const mapStateToProps = (state) => ({ ...state.global });

class Loading1 extends React.Component {
  componentDidMount() {}

  constructor(props) {
    super(props);
  }

  render() {
    return <Loading type="page" show={this.props.showLoading} />;
  }
}

const ReduxLoading = connect(mapStateToProps)(Loading1);

export default ReduxLoading;
